import type { KeysOfType, SectionTarget } from '@accesso/cc-std-lib';

/**
 * Creates an object for defining locales within the storefront.
 *
 * It's expected that you pass in a Record<string, string>, where the value is blank if it matches the target, or the actual target.
 * If the value is blank, we will `.toLowerString()` the key as all sections and targets in storefront must be all lowercase.
 * @param section The section of all the locales.
 * @param locales The targets.
 */
export const defineLocaleTargets = <T extends Record<string, string>>(section: string, locales: T) => {
	type Key = KeysOfType<T>;
	const obj: Record<Key, SectionTarget> = {} as Record<Key, SectionTarget>;

	Object.keys(locales).forEach((key: Key) => {
		obj[key] = `${section}.${locales[key]?.length ? locales[key] : key.toString().toLowerCase()}`;
	});

	return obj;
};
